import { MessageDescriptor } from '@lingui/core';
import { useFormContext } from 'react-hook-form';

import { getPollIcon } from './helpers/getPollIcon';
import { TMarketingForm } from './MarketingPoll';
import styles from './PollOptionButton.module.css';
import { useLocale } from '../../hooks/useLocale';

export type TPollOption = {
  id: string;
  // UK options are plain English strings; DE options are Lingui messages.
  name: string | MessageDescriptor;
};

const PollOptionButton = ({
  option,
  onChange,
}: {
  option: TPollOption;
  onChange: () => void;
}) => {
  const { register } = useFormContext<TMarketingForm>();
  const { i18n } = useLocale();

  const optionName =
    typeof option.name === 'string' ? option.name : i18n._(option.name);

  return (
    <label className={styles.marketingPollBtn}>
      {getPollIcon(option.id)}
      <p className={styles.pollName} aria-label={optionName}>
        {optionName}
      </p>
      <input
        type="radio"
        {...register('answer')}
        value={option.id}
        className={styles.marketingPollInput}
        onInput={onChange}
      />
    </label>
  );
};

export default PollOptionButton;
